var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('BaseButton',{attrs:{"loading":_vm.isDownloading,"size":"sm"},on:{"click":_vm.handleDownload}},[_vm._v("Download")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }